(function($){
    //lazy load stylesheet
    function loadStyleSheet(src) {
        if (document.createStyleSheet){
            document.createStyleSheet(src);
        }
        else {
            $("head").append($("<link rel='stylesheet' href='"+src+" />"));
        }
    };

    
	/* Get accurate Viewport sizing (no jQuery) */
    var viewportwidth;
    var viewportheight;

    function getWindowSize(){
        if (typeof window.innerWidth != 'undefined'){
            viewportwidth = window.innerWidth,
            viewportheight = window.innerHeight
        }else if (typeof document.documentElement != 'undefined' && typeof document.documentElement.clientWidth != 'undefined' && document.documentElement.clientWidth != 0){
            viewportwidth = document.documentElement.clientWidth,
            viewportheight = document.documentElement.clientHeight
        }else{
            viewportwidth = document.getElementsByTagName('body')[0].clientWidth,
            viewportheight = document.getElementsByTagName('body')[0].clientHeight
        }
    }


    $('.lazy').Lazy();
    
    function initSlider() {
        $('.slider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            infinite: true,
            speed: 500,
            cssEase: 'linear',
            responsive: [
                {
                    breakpoint: 1180,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
        
        $('.innovation--slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            infinite: true,
            speed: 500,
            cssEase: 'linear',
            fade: true,
            adaptiveHeight: true
        });
        
        $('.team--slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            infinite: true,
            speed: 500,
            cssEase: 'linear',
            fade: true,
            adaptiveHeight: true
        });
    }

	/* Document Ready */
	$(document).ready(function() {
		getWindowSize();
        
        AOS.init({
            duration: 400,
            once: true,
        });
        
        initSlider();

        //Sidr
        $('#mobile-trigger').sidr({
            side: 'left',
            name: 'sidr',
            displace: false,
            source : function() {
                return '<div id="mobile-menu"><span class="sidr__close" aria-label="Close Menu"></span><div class="sidr__logo">' + $('.site-header .site-logo').html() + '</div><div class="sidr__inner"><div class="sidr__mainnav">' + $('#site-navigation').html() + '</div></div></div>';
            },
//            onOpen: function() {
//                //alert('test');
//                $( 'body' ).prepend( '<div class="sidr-overlay"></div>' );
//            },
            onOpenEnd: function(){
                $( 'body' ).css({
                    "position": "fixed",
                    "left": "0",
                    "top": "0",
                    "width": "100%"
                });
            },
//            onClose: function(){
//                $( '.sidr-overlay' ).remove();
//            },
            onCloseEnd: function(){
                $( 'body' ).css({
                    "position": "relative",
                    "left": "auto",
                    "top": "auto",
                    "width": "100%"
                });
            }
        });
        $('.menu-item-has-children .arrow').click(function(e) {
            e.preventDefault();
            $(this).toggleClass('active').next().slideToggle();
        });
        $('.sidr__close').click(function() {
            $.sidr('close','sidr');
        });
        
        
        if($('.woocommerce-filter').length){
            $('.woocommerce-filter').find('.woocommerce-filter--filter').each(function(){
                $(this).children('.woocommerce-filter--name').on('click', function(e) {
                    e.preventDefault();
                    $(this).parent().siblings().children('.woocommerce-filter--name').removeClass('active');
                    $(this).parent().siblings().children('.woocommerce-filter--details').hide();
                    $(this).toggleClass('active');
                    $(this).next().slideToggle('fast');
                });
            });
        }
        
        if($('.product--tabs--container').length){
            $('.product--tabs--container').find('.product--tabs').each(function(){
                
                var firstId = $(this).children('li').first().data('id');
                $(this).children('li').first().addClass('active');
                $('#' + firstId ).addClass('active');
                
                $(this).children('li').on('click', function() {
                    var anchorId = $(this).data('id');
                    
                    $(this).siblings().removeClass('active');
                    $('#' + anchorId ).siblings().removeClass('active');
                    
                    $(this).addClass('active');
                    $('#' + anchorId ).addClass('active');
                    
                });
            });
            $('.product--tabs--container').find('.product--tabs--content').each(function(){
                $(this).on('click', function() {
                    var contentId = $(this).attr('id');
                    
                    $(this).siblings().removeClass('active');
                    $('li[data-id="' + contentId + '"]' ).siblings().removeClass('active');

                    $(this).addClass('active');
                    $('li[data-id="' + contentId + '"]' ).addClass('active');
                    
                });
            });
        }
        
        $('.js-search-toggle').on('click', function(e) {
            e.preventDefault();
            
            $('.site-search').slideToggle();
        });
        
        $('#review_form_trigger').on('click', function(e) {
            e.preventDefault();
            
            $('#review_form_wrapper').find('#review_form').slideToggle();
        });
        
        $('#js-myaccount-toggle').on('click', function(e) {
            e.preventDefault();
            
            $(this).toggleClass('active').next().slideToggle();
        });
        
        //default woocommerce sort order styling
        $('.woocommerce-ordering .orderby').selectWoo();
        
        $('.popup-partner').magnificPopup({
            delegate: 'a',
            type: 'image',
            tLoading: 'Loading image #%curr%...',
            mainClass: 'mfp-img-mobile',
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0,1] // Will preload 0 - before current, and 1 after the current image
            },
            image: {
                tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
                titleSrc: function(item) {
//                    return item.el.attr('title') + '<small>by Marsel Van Oosten</small>';
                    return item.el.attr('title');
                }
            }
        });
//        $('.partner--section .partner').masonry({
//            // options
//            itemSelector: '.partner--item',
//            // use element for option
//            columnWidth: '.partner--sizer',
//            percentPosition: true
//        });
        // init Masonry
        var $grid = $('.partner--section .partner').masonry({
            // options...
            itemSelector: '.partner--item',
            // use element for option
            columnWidth: '.partner--sizer',
            percentPosition: true
        });
        // layout Masonry after each image loads
        $grid.imagesLoaded().progress( function() {
            $grid.masonry('layout');
        });
        
        
        /* YouTube Video Embed */
        var $video_icon = $('.video_icon');
        if ($video_icon.length) {
            var tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            $video_icon.on("click", function() {
                var $this = $(this),
                    $youtube_id = $(this).data('youtubeid'),
                    $video_id = $(this).data('videoid'),
                    $parent = $(this).parents('.video_parent');
                $this.fadeOut(300);
                $this.parent('.video--content').fadeOut(300);
                player = new YT.Player($video_id, {
                    videoId: $youtube_id,
                    height: $parent.outerHeight(),
                    width: $parent.outerWidth(),
                    playerVars: {rel: 0},
                    events: {
                        'onReady' : onPlayerReady
                    }
                });

            });
        }

        function onPlayerReady(event) {
            event.target.playVideo();
        }
        
        $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false
        });
	});

	$(window).on("resize", function() {
		getWindowSize();
	});

    
    $(window).load(function(){
        $('#page-loading').delay(500).fadeOut("slow", function() {
            $('body').removeClass('loading').addClass('loaded');
            
            $( ".hero--home h1" ).animate({
                    opacity: 1,
                }, 800);
            $( ".hero--home .subheading" ).delay(700).animate({
                    opacity: 1,
                }, 800);
            $( ".hero--home p" ).delay(1500).animate({
                    opacity: 1,
                }, 800);
            $( ".hero--home .button" ).delay(2000).animate({
                    opacity: 1,
                }, 800);
        });
    });

})(jQuery);